// Compare page twin troller bottom button redirect script
$(document).ready(function(){
  $('.twin_troller').on('click', function(){
    // Assign your product handle here
    var productHandle = 'the-twin-troller-x10-small-electric-fishing-boat-shadow-series';

    // Construct the URL to the product page
    var productUrl = '/products/' + productHandle;

    // Redirect to the product page
    window.location.href = productUrl;
  });
});

// Compare page twin troller deluxe bottom button redirect script
$(document).ready(function(){
  $('.twin_troller_deluxe').on('click', function(){
    // Assign your product handle here
    var productHandle = 'the-twin-troller-x10-deluxe';

    // Construct the URL to the product page
    var productUrl = '/products/' + productHandle;

    // Redirect to the product page
    window.location.href = productUrl;
  });
});



$(document).on('mouseenter', '.menu-drawer a[href="#"]', function() {
    $(this).css('pointer-events', 'none');
});



$(document).ready(function(){
	$('#partners_reviews').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		nav:false,
		pagination:false,  dots: true,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:3
	        }
	    }
	}); 

// Delay the start of setInterval using setTimeout
setTimeout(function() {
    setInterval(function() {
        jQuery('.releted_slider').owlCarousel({
            margin:60,
            loop:true,
            slideSpeed : 300,
            paginationSpeed : 400,
            autoplay:true,
            nav:true,
            pagination:false,  
            dots: true,
            navText: ["<img src='https://cdn.shopify.com/s/files/1/0527/5857/7312/files/Vector_32.png'>","<img src='https://cdn.shopify.com/s/files/1/0527/5857/7312/files/Vector_33.png'>"],
            responsive:{
                0:{
                    items:1
                },
                480:{
                    items:1
                },
                700:{
                    items:2
                },
                1000:{
                    items:3
                },
                1100:{
                    items:3
                }
            }
        }); 
    }, 2000);  // The interval time (2 seconds) for repeatedly executing the code.
}, 1000); // The timeout delay (2 seconds) before starting the interval


  

  

  // FAQ Js Start

   jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });


    jQuery(document).ready(function(){
jQuery(".tab-btn").click(function(){

  var id_tab=jQuery(this).attr("data-val");
  jQuery(".tab-btn").removeClass("active");
  jQuery(this).addClass("active");
  
  jQuery(".product-tab-body").removeClass("active");
  jQuery(".product-tab-body."+id_tab).addClass("active");
});
    
});
 
});


$(document).ready(function(){
    $(".page_products .banner-bottom-menu-area .breadcrumb>li.active a").text("Ready To Buy");
});


















